<template>
  <div class="center-content justify-center align-center">
    <div v-if="loading">Loading...</div>
    <div v-else-if="finish">
      OK
    </div>
    <div v-else-if="start">
      <h1 class="text-center">{{ingText}}</h1>
      <form @submit.prevent="textInputSubmit()">
        <v-text-field
          full-width
          autofocus
          v-model="textInput"
        ></v-text-field>
      </form>
      <h3 class="text-center">{{answers.length+1}}/{{totalAnswerCount}}</h3>
    </div>
    <div v-else>
      <h1 class="big-title text-center">{{startCounting}}</h1>
    </div>
  </div>
</template>
<script>
import firebase from "@/firebase";
import moment from "moment";
export default {
  data() {
    return {
      loading: true,
      finish: false,
      totalAnswerCount: 3,
      start: true,
      startCounting: 3,
      startInterval: null,
      textInput: "",
      ingText: "",
      types: [],
      answers: [],
      answerTimeStart: null
    };
  },
  methods: {
    // typesSet() {
    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const snapshot = await firebase.db
    //         .collection("general")
    //         .doc("pratices")
    //         .get();
    //       this.types = snapshot.data().types;
    //       resolve();
    //     } catch (error) {
    //       reject(error);
    //     }
    //   });
    // },
    finishSet() {},
    ingTextSet() {
      const index = Math.floor((this.types.length + 1) * Math.random());
      this.ingText = this.types[index];
      this.answerTimeStart = moment();
    },
    textInputSubmit() {
      let answerTimeStart = moment();
      this.answers.push({
        text: this.ingText,
        answer: this.textInput,
        time: answerTimeStart.diff(this.answerTimeStart)
      });
      if (this.answers.length >= this.totalAnswerCount) {
        this.finish = true;
        this.textInputReset();
        this.finishSet();
        return;
      } else {
        this.ingTextSet();
        this.textInputReset();
        return;
      }
    },
    textInputReset() {
      this.textInput = "";
    },
    handleKeyup($event) {
      if ($event.key == "Enter" && this.start == false) {
        this.start = true;
        return;
      } else {
        return;
      }
    },
    startCountingAct() {
      if (this.startCounting - 1 <= 0) {
        this.start = true;
        clearInterval(this.startInterval);
      } else {
        this.startCounting--;
      }
    },
    countingStart() {
      this.startInterval = setInterval(() => {
        this.startCountingAct();
      }, 1000);
    }
  },
  async mounted() {
    const snapshot = await firebase.db
      .collection("general")
      .doc("practices")
      .get();
    this.types = snapshot.data().types;
    this.loading = false;
    this.ingTextSet();
  }
};
</script>